import { computed } from "vue";

// For manual fetch/JSON requests (non-Inertia responses), Rails still expects a CSRF token.
export const useCsrfToken = () =>
  computed(() => {
    if (typeof document === "undefined") return "";

    return (
      document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content") || ""
    );
  });
